import axios from 'axios'

const apiUrl = process.env.RITETAG_API_URL

let API_TOKEN = false

const instance = axios.create({
    baseURL: apiUrl,
    timeout: 30000,
    withCredentials: true,
})

const getInstance = () => {
    return instance
}

function getCode (email, create = false) {
    const data = {
        email: email
    }
    if (create) {
        data.create = '1'
    }
    return getInstance().post('v1/sign/code', data)
}

function userInfo() {
    return getInstance().get(`v1/user/info`)
}

function tagsetRead(id = null) {
    return getInstance().get(`v1/composer/tagsets` + (id ? `/${id}` : ''))
}

function tagsetCreate(params = {}) {
    return getInstance().post(`v1/composer/tagsets`, params)
}

function tagsetRemove(id) {
     return getInstance().delete(`v1/composer/tagsets/${id}`)
}

function hashtagStats(hashtag) {
    if (!Array.isArray(hashtag)) {
        hashtag = [hashtag]
    }
    return getInstance().get(`v1/stats/multiple-hashtags?tags=` + hashtag.join(','))
}

function hashtagSuggestion(data) {
    // TODO validate parameters
    return getInstance().post(`v2/stats/hashtag-suggestions`, data)
}

function uploadImage(formData) {
    return getInstance().post('v2/file/image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

function instagramBlacklist(params) {
    return getInstance().post('/instagram/blacklist', params)
}

function instagramCleaner(data){
    return getInstance().post('v2/instagram/hashtags-cleaner?' + data)
}

function setToken(token) {
    // console.log('TOKEN:     ' + token)
    API_TOKEN = token
    getInstance().defaults['headers']['Authorization'] = 'Token ' + token
}

function hashtagReports() {
    return getInstance().get('v2/report/list')
}

function publishReport(uuid) {
    // API returns 404 - fix needed
    return getInstance().post('v2/report/publish?uuid=' + uuid)
}

function publishInstagramReport(uuid) {
    // API returns 404 - fix needed
    return getInstance().post('v2/instagram-report/publish?uuid=' + uuid)
}

function instagramReports() {
    return getInstance().get('v2/instagram-report/list')
}

function searchHashtags(hashtag, limit) {
    return getInstance().get('v1/search/hashtags/' + hashtag + '?limit=' + limit)
}

function getInstagramReport(uuid) {
    return getInstance().get('v2/instagram-report/data?uuid=' + uuid)
}

function getInstagramCalc(instagramId, start, end) {
    return getInstance().post('v2/instagram-report/calc', {
        instagramId: instagramId,
        startAt: start,
        endAt: end
    })
}


/**
 * payments
 * @returns {AxiosPromise<any>}
 */
function getCountries () {
    return getInstance().get('v2/payments/countries')
}

function getPaymentToken () {
    return getInstance().get('v2/payments/token')
}

function payInstagramReport (query) {
    return getInstance().post('v2/payments/instagram-report', query)
}

function startTrial (server) {
    return getInstance().post('v1/user/start-trial?server=' + server)
}

function getAccounts () {
    return getInstance().get('v1/composer/accounts')
}

function getUrl (url) {
    return axios.get(url)
}

function getPresets () {
    return getInstance().get('v1/enhance/sets')
}

function getPresetDetail (id) {
    return getInstance().get('v1/enhance/sets/' + id)
}

function enhanceWithPreset (enhanceId, post) {
    return getInstance().get('v1/enhance/enhance?enhanceId=' + enhanceId + '&post=' + post)
}

function enhanceCustom (setting, post) {
    return getInstance().get('v1/enhance/enhance?enhance', {
        params: {
            extractImage: setting.extractImage ? 1 : 0,
            quoteImage: setting.quoteImage ? setting.quoteImageFrom : 0,
            autoHashtags: setting.autoHashtags ? 1 : 0,
            maxHashtags: setting.maxHashtags,
            hashtagPosition: setting.hashtagPosition,
            autoEmoji: setting.autoEmoji ? 1 : 0,
            shortLink: setting.shortLink ? setting.shortLinkWith : 0,
            twitterCreator: setting.twitterHandler ? 1 : 0,
            appendText: setting.appendText ? setting.appendTextWith : '',
            post: post
        }
    })
}

function postToQueue (formData) {
    return getInstance().post('v2/composer/post', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

function getImageWithSource (source, image) {
    return getInstance().get('v1/images/' + source + '/' + image)
}

export const api = {
    userInfo,
    tagsetRead,
    tagsetCreate,
    tagsetRemove,
    hashtagStats,
    hashtagSuggestion,
    instagramBlacklist,
    instagramCleaner,
    setToken,
    hashtagReports,
    publishReport,
    publishInstagramReport,
    instagramReports,
    searchHashtags,
    getInstagramReport,
    getCountries,
    getPaymentToken,
    getInstagramCalc,
    uploadImage,
    payInstagramReport,
    startTrial,
    getAccounts,
    getUrl,
    getPresets,
    getPresetDetail,
    enhanceWithPreset,
    enhanceCustom,
    postToQueue,
    getImageWithSource,
    getCode,
}
